import { render, staticRenderFns } from "./GeneralEditingSettings.vue?vue&type=template&id=7e4cc5f2&scoped=true&lang=html&"
import script from "./GeneralEditingSettings.vue?vue&type=script&lang=js&"
export * from "./GeneralEditingSettings.vue?vue&type=script&lang=js&"
import style0 from "./GeneralEditingSettings.vue?vue&type=style&index=0&id=7e4cc5f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4cc5f2",
  null
  
)

export default component.exports